export function pickApprovalProgressStep(steps) {
    if (steps.length === 1) {
        return steps[0]
    }

    return steps.find((step) => step?.status === 'approved' || step?.status === 'rejected') ?? steps[0]
}

export function collapseApprovalProgressSteps(steps = []) {
    const groupedSteps = steps.reduce((accumulator, step, index) => {
        const level = step?.level ?? step?.approver?.level ?? index

        if (!accumulator[level]) {
            accumulator[level] = []
        }

        accumulator[level].push(step)
        return accumulator
    }, {})

    return Object.keys(groupedSteps)
        .sort((levelA, levelB) => Number(levelA) - Number(levelB))
        .map((level) => pickApprovalProgressStep(groupedSteps[level]))
}
